import { createSeed } from './mathUtils';

export const SWR_VERIFICATION_VERSION = 'independent-wilson-95-fixed-budget-v1';

export function getSWRVerificationStatus(interval, threshold) {
  if (!Number.isFinite(threshold) || threshold < 0 || threshold > 1 || !interval || !Number.isFinite(interval.lower) || !Number.isFinite(interval.upper)
    || interval.lower < 0 || interval.upper > 1 || interval.lower > interval.upper) return 'unavailable';
  if (interval.upper <= threshold) return 'supported';
  if (interval.lower > threshold) return 'unsupported';
  return 'uncertain';
}

export function buildSWRValidationBlocks(seed, simulations, detailed) {
  if (!Number.isInteger(simulations) || simulations < 1 || simulations > 25000) throw new Error('Numero di percorsi della verifica SWR non valido.');
  const count = detailed ? Math.min(5, simulations) : 1;
  return Array.from({ length: count }, (_, index) => ({
    index: index + 1,
    simulations: Math.floor(simulations / count) + (index < simulations % count ? 1 : 0),
    marketSeed: createSeed(`${seed}:${SWR_VERIFICATION_VERSION}:market:${index}`),
    macroSeed: createSeed(`${seed}:${SWR_VERIFICATION_VERSION}:macro:${index}`),
  }));
}
